<section class="tooltip-wrapper">
  <div class="tooltip-item" *ngIf="selectedCellDetails?.JobAssignmentDescription?.trim().length > 0">
    <label>Engagement Activity</label>
    <span>{{ selectedCellDetails.JobAssignmentDescription }}</span>
  </div>
  <div class="tooltip-item" *ngIf="selectedCellDetails?.JobAssignmentDescr?.trim().length > 0">
    <label>Engagement Activity</label>
    <span>{{ selectedCellDetails.JobAssignmentDescr }}</span>
  </div>
  <div class="tooltip-item" *ngIf="selectedCellDetails?.ComponentDescription?.trim().length > 0">
    <label>Booking Component</label>
    <span>{{ selectedCellDetails.ComponentDescription }}</span>
  </div>
  <div class="tooltip-item" *ngIf="selectedCellDetails?.ComponentDescr?.trim().length > 0">
    <label>Booking Component</label>
    <span>{{ selectedCellDetails.ComponentDescr }}</span>
  </div>
  <div class="tooltip-item" *ngIf="selectedCellDetails?.Description?.trim().length > 0">
    <label>Notes</label>
    <span>{{ selectedCellDetails.Description }}</span>
  </div>
</section>
